export default "__VITE_ASSET__53a65f0e__"